import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Insurance Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const InsuranceView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="insurance"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default InsuranceView;
